import React from 'react';
import styled from 'styled-components';

import { Text } from '../atom/Text';

export const HorizonLine = ({ text = '', ...props }) => {
  return (
    <LineWrapper top="30" {...props}>
      {text && (
        <Text size="14" color="brownGrey" lineHeight="0.1em">
          {text}
        </Text>
      )}
    </LineWrapper>
  );
};

const LineWrapper = styled.div`
  text-align: center;
  border-bottom: 1px solid ${(props) => props.theme.color.brownGrey};
  line-height: 0.1em;
  margin: 10px 0 20px;

  span {
    background: ${(props) => props.theme.color.background};
    padding: 0 30px;
  }
`;
